import { useContext } from "react"
import { HistoricoCaixaContext } from "./HistoricoCaixaContext"

export function useHistoricoCaixaContext() {
    return useContext(HistoricoCaixaContext)
}
